// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inbox-space1-SRDE6 {
	margin-bottom: 6px !important;
}

.Inbox-space2-KvVS7 {
	margin-bottom: 12px !important;
}

.Inbox-space3-TQwy7 {
	margin-bottom: 18px !important;
}

.Inbox-space4-d3wlX {
	margin-bottom: 24px !important;
}

.Inbox-space5-_pi1o {
	margin-bottom: 30px !important;
}

.Inbox-space6-SviTc {
	margin-bottom: 36px !important;
}

.Inbox-space7-vrkSj {
	margin-bottom: 42px !important;
}

.Inbox-spaceTop8-C4umA {
	margin-bottom: 48px !important;
}

.Inbox-spaceTop1-gVEnW {
	margin-top: 6px !important;
}

.Inbox-spaceTop2-rLXS7 {
	margin-top: 12px !important;
}

.Inbox-spaceTop3-e_WZt {
	margin-top: 18px !important;
}

.Inbox-spaceTop4-HS7TB {
	margin-top: 24px !important;
}

.Inbox-spaceTop5-vTlGu {
	margin-top: 30px !important;
}

.Inbox-spaceTop6-hFVNi {
	margin-top: 36px !important;
}

.Inbox-spaceTop7-ds8Fh {
	margin-top: 42px !important;
}

.Inbox-spaceTop8-C4umA {
	margin-top: 48px !important;
}

.Inbox-noMargin-FNryS {
	margin: 0px !important;
}

.Inbox-padding1-VjIMn {
	padding-bottom: 6px !important;
}

.Inbox-padding2-M7rR5 {
	padding-bottom: 12px !important;
}

.Inbox-padding3-OiHS2 {
	padding-bottom: 18px !important;
}

.Inbox-padding4-tawh4 {
	padding-bottom: 24px !important;
}

.Inbox-padding5-r8JyE {
	padding-bottom: 30px !important;
}

.Inbox-padding6-lt1B5 {
	padding-bottom: 36px !important;
}

.Inbox-padding7-z4RQe {
	padding-bottom: 42px !important;
}

.Inbox-paddingTop1-saRqn {
	padding-top: 6px !important;
}

.Inbox-paddingTop2-E5t0R {
	padding-top: 12px !important;
}

.Inbox-paddingTop3-DkYVi {
	padding-top: 18px !important;
}

.Inbox-paddingTop4-KSC6K {
	padding-top: 24px !important;
}

.Inbox-paddingTop5-mQqXa {
	padding-top: 30px !important;
}

.Inbox-paddingTop6-IElrR {
	padding-top: 36px !important;
}

.Inbox-paddingTop7-Mp9Fx {
	padding-top: 42px !important;
}

.Inbox-noPadding-FQnwF {
	padding: 0px !important;
}

.Inbox-textBold-uH3fI {
	font-weight: 500 !important;
}

.Inbox-textBolder-rdA_v {
	font-weight: 700 !important;
}

.Inbox-textNormal-mrhpO {
	font-weight: normal !important;
}

.Inbox-spaceBottom20-J64JN {
	margin-bottom: 20px;
}

.Inbox-spaceBottom10-aZw_Q {
	margin-bottom: 10px;
}

.Inbox-marginNone-mQIJC {
	margin: 0;
}

.Inbox-spaceBottom15-dLiG3 {
	margin-bottom: 15px;
}

.Inbox-marginTopNone-E3V6_ {
	margin-top: 0;
}

.Inbox-spaceTop11-IM9N9 {
	margin-top: 11px;
}

.Inbox-spaceTop21-If6go {
	margin-top: 21px;
}

.Inbox-spaceTop20-RvrOO {
	margin-top: 20px;
}

.Inbox-spaceTop10-JbmbY {
	margin-top: 10px;
}

/*New Design Text Colors */

.Inbox-textDarkBlue-uj5pj {
	color: rgb(20, 39, 94) !important;
}

.Inbox-textLightBlue-s6_fp {
	color: rgb(57, 87, 106) !important;
}

.Inbox-textLightSandleGreen-nzeYE {
	color: rgb(76, 86, 41) !important;
}

.Inbox-textLightBrown-PVrHv {
	color: rgb(115, 79, 33) !important;
}

.Inbox-textMediumMaroon-xnRfI {
	color: rgb(87, 37, 51) !important;
}

.Inbox-textBrown-jsw4O {
	color: rgb(160, 47, 24) !important;
}

.Inbox-textMaroon-JymX7 {
	color: rgb(155, 49, 67) !important;
}

.Inbox-textDarkBrown-CTuLQ {
	color: rgb(83, 18, 16) !important;
}

.Inbox-textMediumBrown-asaXf {
	color: rgb(142, 28, 10) !important;
}

.Inbox-textSkyBlue-U57D3 {
	color: rgb(37, 117, 141) !important;
}

.Inbox-textGray-AGTYz {
	color: rgb(77, 65, 51) !important;
}

.Inbox-textTruncate-bMdnY {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.Inbox-textMuted-rAjzY {
	cursor: pointer;
	display: block;
}

.Inbox-listLayout-NHvv6 {
	margin-bottom: 0;
	padding-left: 0;
	list-style: none;
}

/*************************verification Styles end******************************************/

.Inbox-profileAvatarLink-bYMgu {
	position: relative;
	display: inline-block;
	z-index: 4;
}

.Inbox-profileAvatar-yjjov {
	border-radius: 50% !important;
}

.Inbox-displayTable-zWY4N {
	display: table;
	width: 100%;
}

.Inbox-displayTableRow-cOHaD {
	width: 100%;
	display: table-row;
}

.Inbox-displayTableCell-uZNaj {
	display: table-cell;
	vertical-align: middle;
}

.Inbox-IconWidth-wEorb {
	width: 10%;
	padding-right: 20px;
	vertical-align: top;
}

.Inbox-rightBg-s2_qR {
	position: relative;
	width: 90%;
}

.Inbox-progressContainerResponsive-cVnOU {
	margin-left: auto;
	margin-right: auto;
	max-width: var(--max-content-width);
	width: 100%;
}

.Inbox-displayGrid-Xme2u {
	display: grid;
	grid-template-columns: 15% 63% 20%;
	grid-gap: 6px;
}

.Inbox-PanelBody-VUVfw {
	background-color: transparent;
	border-radius: 12px 12px 12px 0px;
	padding: 0;
	margin-bottom: 18px;
}

.Inbox-contentText-_ivlh {
	font-size: 14px;
	line-height: 16px;
	letter-spacing: 0px;
	color: var(--primary-link-foreground);
	margin-bottom: 14px;
}

.Inbox-cityText-N01vp {
	font-size: 14px;
	line-height: 16px;
	color: var(--primary-link-foreground);
	margin-bottom: 0;
}

.Inbox-dislayNameText-AKZ6d {
	font-size: 16px;
	line-height: 19px;
}

.Inbox-listAvatarGrid-Ihmks {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	margin-bottom: 18px;
	-webkit-column-gap: 8px;
	   -moz-column-gap: 8px;
	        column-gap: 8px;
}

.Inbox-listDeatilsGrid-KmcOI {
	width: 100%;
	background-color: var(--primary-gray-bg);
	padding: 25px;
	border-radius: 0 8px 8px 8px;
	position: relative;
	gap: 15px;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
}

.Inbox-inboxAvaterWidth-D5i6d {
	min-width: 120px;
}

.Inbox-loadMore-F1W5k {
	text-align: center;
}

@media screen and (max-width: 768px) {
	.Inbox-progressContainerResponsive-cVnOU {
		padding: 0;
		margin: 0;
		overflow: hidden;
	}
}

@media screen and (max-width: 767px) {
	.Inbox-displayGrid-Xme2u {
		grid-template-columns: 100%;
	}

	.Inbox-IconWidth-wEorb {
		vertical-align: top;
	}

	.Inbox-contentText-_ivlh {
		margin-bottom: 3px;
	}

	.Inbox-dislayNameText-AKZ6d {
		margin-bottom: 3px;
	}

	.Inbox-cityText-N01vp {
		margin-bottom: 6px;
	}

	.Inbox-listDeatilsGrid-KmcOI {
		grid-template-columns: 100%;
	}
}

/* ============================================================
   EMPTY MESSAGES STATE
   ============================================================ */

.Inbox-emptyMessagesContainer-trwu6 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	padding: 40px 20px;
	text-align: center;
}

.Inbox-emptyMessagesIconWrapper-ThedV {
	position: relative;
	margin-bottom: 18px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.Inbox-emptyMessagesRays-uDxCS {
	position: absolute;
	top: -6px;
	right: -10px;
	pointer-events: none;
}

.Inbox-emptyMessagesCircle-iZ4VP {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: #e5f4ff;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}

.Inbox-emptyMessagesTitle-FLI4s {
	font-family: var(--font-family-base) !important;
	font-size: 17px;
	font-weight: 700;
	color: var(--secondary-oscuro);
	margin: 0 0 8px 0;
}

.Inbox-emptyMessagesSubtitle-JFW3_ {
	font-family: var(--font-family-base) !important;
	font-size: 13px;
	color: var(--tertiary-foreground);
	margin: 0;
	max-width: 320px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Dashboard/Inbox.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA,2FAA2F;;AAC3F;CACC,kBAAkB;CAClB,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mCAAmC;CACnC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,aAAa;AACd;;AAEA;CACC,6BAA6B;CAC7B,iCAAiC;CACjC,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,qCAAqC;CACrC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAmB;CACnB,uBAAe;IAAf,oBAAe;SAAf,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,wCAAwC;CACxC,aAAa;CACb,4BAA4B;CAC5B,kBAAkB;CAClB,SAAS;CACT,aAAa;CACb,qCAAqC;AACtC;;AAGA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,UAAU;EACV,SAAS;EACT,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,2BAA2B;CAC5B;AACD;;AAEA;;iEAEiE;;AAEjE;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,iBAAiB;AAClB;;AAEA;CACC,+CAA+C;CAC/C,eAAe;CACf,iCAAiC;CACjC,SAAS;CACT,gBAAgB;AACjB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n.textTruncate {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.textMuted {\n\tcursor: pointer;\n\tdisplay: block;\n}\n\n.listLayout {\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n/*************************verification Styles end******************************************/\n.profileAvatarLink {\n\tposition: relative;\n\tdisplay: inline-block;\n\tz-index: 4;\n}\n\n.profileAvatar {\n\tborder-radius: 50% !important;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\twidth: 100%;\n\tdisplay: table-row;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.IconWidth {\n\twidth: 10%;\n\tpadding-right: 20px;\n\tvertical-align: top;\n}\n\n.rightBg {\n\tposition: relative;\n\twidth: 90%;\n}\n\n.progressContainerResponsive {\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmax-width: var(--max-content-width);\n\twidth: 100%;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 15% 63% 20%;\n\tgrid-gap: 6px;\n}\n\n.PanelBody {\n\tbackground-color: transparent;\n\tborder-radius: 12px 12px 12px 0px;\n\tpadding: 0;\n\tmargin-bottom: 18px;\n}\n\n.contentText {\n\tfont-size: 14px;\n\tline-height: 16px;\n\tletter-spacing: 0px;\n\tcolor: var(--primary-link-foreground);\n\tmargin-bottom: 14px;\n}\n\n.cityText {\n\tfont-size: 14px;\n\tline-height: 16px;\n\tcolor: var(--primary-link-foreground);\n\tmargin-bottom: 0;\n}\n\n.dislayNameText {\n\tfont-size: 16px;\n\tline-height: 19px;\n}\n\n.listAvatarGrid {\n\tdisplay: flex;\n\tmargin-bottom: 18px;\n\tcolumn-gap: 8px;\n}\n\n.listDeatilsGrid {\n\twidth: 100%;\n\tbackground-color: var(--primary-gray-bg);\n\tpadding: 25px;\n\tborder-radius: 0 8px 8px 8px;\n\tposition: relative;\n\tgap: 15px;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n}\n\n\n.inboxAvaterWidth {\n\tmin-width: 120px;\n}\n\n.loadMore {\n\ttext-align: center;\n}\n\n@media screen and (max-width: 768px) {\n\t.progressContainerResponsive {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\toverflow: hidden;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.displayGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.IconWidth {\n\t\tvertical-align: top;\n\t}\n\n\t.contentText {\n\t\tmargin-bottom: 3px;\n\t}\n\n\t.dislayNameText {\n\t\tmargin-bottom: 3px;\n\t}\n\n\t.cityText {\n\t\tmargin-bottom: 6px;\n\t}\n\n\t.listDeatilsGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n}\n\n/* ============================================================\n   EMPTY MESSAGES STATE\n   ============================================================ */\n\n.emptyMessagesContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 40px 20px;\n\ttext-align: center;\n}\n\n.emptyMessagesIconWrapper {\n\tposition: relative;\n\tmargin-bottom: 18px;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.emptyMessagesRays {\n\tposition: absolute;\n\ttop: -6px;\n\tright: -10px;\n\tpointer-events: none;\n}\n\n.emptyMessagesCircle {\n\twidth: 64px;\n\theight: 64px;\n\tborder-radius: 50%;\n\tbackground-color: #e5f4ff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.emptyMessagesTitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 17px;\n\tfont-weight: 700;\n\tcolor: var(--secondary-oscuro);\n\tmargin: 0 0 8px 0;\n}\n\n.emptyMessagesSubtitle {\n\tfont-family: var(--font-family-base) !important;\n\tfont-size: 13px;\n\tcolor: var(--tertiary-foreground);\n\tmargin: 0;\n\tmax-width: 320px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Inbox-space1-SRDE6`,
	"space2": `Inbox-space2-KvVS7`,
	"space3": `Inbox-space3-TQwy7`,
	"space4": `Inbox-space4-d3wlX`,
	"space5": `Inbox-space5-_pi1o`,
	"space6": `Inbox-space6-SviTc`,
	"space7": `Inbox-space7-vrkSj`,
	"spaceTop8": `Inbox-spaceTop8-C4umA`,
	"spaceTop1": `Inbox-spaceTop1-gVEnW`,
	"spaceTop2": `Inbox-spaceTop2-rLXS7`,
	"spaceTop3": `Inbox-spaceTop3-e_WZt`,
	"spaceTop4": `Inbox-spaceTop4-HS7TB`,
	"spaceTop5": `Inbox-spaceTop5-vTlGu`,
	"spaceTop6": `Inbox-spaceTop6-hFVNi`,
	"spaceTop7": `Inbox-spaceTop7-ds8Fh`,
	"noMargin": `Inbox-noMargin-FNryS`,
	"padding1": `Inbox-padding1-VjIMn`,
	"padding2": `Inbox-padding2-M7rR5`,
	"padding3": `Inbox-padding3-OiHS2`,
	"padding4": `Inbox-padding4-tawh4`,
	"padding5": `Inbox-padding5-r8JyE`,
	"padding6": `Inbox-padding6-lt1B5`,
	"padding7": `Inbox-padding7-z4RQe`,
	"paddingTop1": `Inbox-paddingTop1-saRqn`,
	"paddingTop2": `Inbox-paddingTop2-E5t0R`,
	"paddingTop3": `Inbox-paddingTop3-DkYVi`,
	"paddingTop4": `Inbox-paddingTop4-KSC6K`,
	"paddingTop5": `Inbox-paddingTop5-mQqXa`,
	"paddingTop6": `Inbox-paddingTop6-IElrR`,
	"paddingTop7": `Inbox-paddingTop7-Mp9Fx`,
	"noPadding": `Inbox-noPadding-FQnwF`,
	"textBold": `Inbox-textBold-uH3fI`,
	"textBolder": `Inbox-textBolder-rdA_v`,
	"textNormal": `Inbox-textNormal-mrhpO`,
	"spaceBottom20": `Inbox-spaceBottom20-J64JN`,
	"spaceBottom10": `Inbox-spaceBottom10-aZw_Q`,
	"marginNone": `Inbox-marginNone-mQIJC`,
	"spaceBottom15": `Inbox-spaceBottom15-dLiG3`,
	"marginTopNone": `Inbox-marginTopNone-E3V6_`,
	"spaceTop11": `Inbox-spaceTop11-IM9N9`,
	"spaceTop21": `Inbox-spaceTop21-If6go`,
	"spaceTop20": `Inbox-spaceTop20-RvrOO`,
	"spaceTop10": `Inbox-spaceTop10-JbmbY`,
	"textDarkBlue": `Inbox-textDarkBlue-uj5pj`,
	"textLightBlue": `Inbox-textLightBlue-s6_fp`,
	"textLightSandleGreen": `Inbox-textLightSandleGreen-nzeYE`,
	"textLightBrown": `Inbox-textLightBrown-PVrHv`,
	"textMediumMaroon": `Inbox-textMediumMaroon-xnRfI`,
	"textBrown": `Inbox-textBrown-jsw4O`,
	"textMaroon": `Inbox-textMaroon-JymX7`,
	"textDarkBrown": `Inbox-textDarkBrown-CTuLQ`,
	"textMediumBrown": `Inbox-textMediumBrown-asaXf`,
	"textSkyBlue": `Inbox-textSkyBlue-U57D3`,
	"textGray": `Inbox-textGray-AGTYz`,
	"textTruncate": `Inbox-textTruncate-bMdnY`,
	"textMuted": `Inbox-textMuted-rAjzY`,
	"listLayout": `Inbox-listLayout-NHvv6`,
	"profileAvatarLink": `Inbox-profileAvatarLink-bYMgu`,
	"profileAvatar": `Inbox-profileAvatar-yjjov`,
	"displayTable": `Inbox-displayTable-zWY4N`,
	"displayTableRow": `Inbox-displayTableRow-cOHaD`,
	"displayTableCell": `Inbox-displayTableCell-uZNaj`,
	"IconWidth": `Inbox-IconWidth-wEorb`,
	"rightBg": `Inbox-rightBg-s2_qR`,
	"progressContainerResponsive": `Inbox-progressContainerResponsive-cVnOU`,
	"displayGrid": `Inbox-displayGrid-Xme2u`,
	"PanelBody": `Inbox-PanelBody-VUVfw`,
	"contentText": `Inbox-contentText-_ivlh`,
	"cityText": `Inbox-cityText-N01vp`,
	"dislayNameText": `Inbox-dislayNameText-AKZ6d`,
	"listAvatarGrid": `Inbox-listAvatarGrid-Ihmks`,
	"listDeatilsGrid": `Inbox-listDeatilsGrid-KmcOI`,
	"inboxAvaterWidth": `Inbox-inboxAvaterWidth-D5i6d`,
	"loadMore": `Inbox-loadMore-F1W5k`,
	"emptyMessagesContainer": `Inbox-emptyMessagesContainer-trwu6`,
	"emptyMessagesIconWrapper": `Inbox-emptyMessagesIconWrapper-ThedV`,
	"emptyMessagesRays": `Inbox-emptyMessagesRays-uDxCS`,
	"emptyMessagesCircle": `Inbox-emptyMessagesCircle-iZ4VP`,
	"emptyMessagesTitle": `Inbox-emptyMessagesTitle-FLI4s`,
	"emptyMessagesSubtitle": `Inbox-emptyMessagesSubtitle-JFW3_`
};
module.exports = ___CSS_LOADER_EXPORT___;
